import { memo } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'LengthLabel' })((theme) => ({
  position: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  noLabelPosition: {
    top: theme.spacing(3 * -1),
  },
}));

interface LengthLabelProps {
  readonly hasLabel: boolean;
  readonly value: string;
  readonly maxLength: number;
}

export const LengthLabel = memo<LengthLabelProps>(({ hasLabel, value, maxLength }) => {
  const { classes, cx } = useStyles();

  const currentLength = value?.length || 0;
  const target = maxLength || 0;

  return (
    <Typography
      variant="body1"
      color={currentLength <= target ? 'disabled' : 'error'}
      className={cx(classes.position, !hasLabel && classes.noLabelPosition)}
      component="span"
    >
      {currentLength}

      /
      {target}
    </Typography>
  );
});
